export function comparisonUnavailableReason(periods: any, from: string, to: string, compare: string): string | null {
  if (!from || !to || !['year', 'term'].includes(compare)) return null;
  const years = periods?.calendar?.years || [];
  const selected = years.find(year => year.start <= from && year.end >= to);
  if (compare === 'year') {
    if (!selected) return 'No academic calendar covers this reporting period.';
    const previous = years.find(year => year.end < selected.start &&
      Number(year.start.slice(0, 4)) === Number(selected.start.slice(0, 4)) - 1);
    return previous ? null : `No previous academic year is available for ${selected.name}.`;
  }
  const terms = years.reduce((all, year) => all.concat(year.terms || []), []);
  const selectedTerm = terms.find(term => term.start <= from && term.end >= to);
  return selectedTerm && terms.some(term => term.end < selectedTerm.start)
    ? null : 'No previous term is available for this reporting period.';
}

// Only expected comparison limitations can disable a comparison automatically.
// Permission, network, database and integrity failures remain visible errors.
export function isUnavailableComparisonError(error: any): boolean {
  if (![400, 409, 422].includes(error?.response?.status)) return false;
  const text = error?.response?.data?.details?.text || '';
  return text === 'Configure the current and previous academic years before comparing them.' ||
    text === 'Configure this term and the previous term in the academic calendar first.' ||
    text.startsWith('Historical school roster is unavailable for ') ||
    text.startsWith('These dates do not fit the previous academic year.') ||
    text.startsWith('The previous term is shorter than this selection.') ||
    text.startsWith('Period comparison is unavailable for undated current club enrolments.');
}

export function withoutComparison(params: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(params.toString());
  next.set('compare', 'none');
  ['compareFrom', 'compareTo', 'snapshotId'].forEach(key => next.delete(key));
  return next;
}
